import { handleActions } from 'redux-actions';
import { Actions, loginSuccess } from 'actions/sessionActions';
import { PermissionSet } from 'shared/models';

export type State = Readonly<{
    userId: string | null;
    permissions: PermissionSet;
}>;

export const initialState = Object.freeze<State>({
    userId: null,
    permissions: {},
});

export const sessionReducer = handleActions({
    [Actions.LOGIN_SUCCESS]: (state: State, action: ReturnType<typeof loginSuccess>) => {
        const { user, permissions } = action.payload;
        return {
            userId: user.id,
            permissions,
        };
    },
    [Actions.LOGOUT_SUCCESS]: () => {
        return initialState;
    },
}, initialState);
